import { ImageProps } from '@features/powerpoint';
import { legend as legendImagePath } from '@features/lci-report/images/lci-adaptive-synthetic-control';

export const legend: ImageProps = {
  path: legendImagePath,
  x: 11.57,
  y: 1.75,
  w: 0.99,
  h: 0.5,
};
